export * from "./slate";

/**
 * The type of data the editor should use
 */
export enum DataType {
  PlainText,
  Html,
}

interface CoreProps {
  dataType: DataType;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  initialValue: string;
  toolbarOptions?: ToolbarOptions[];
  toolbarBoundingElem?: string; // note that this is a selector, not just a classname
  readOnly?: boolean;
  placeholder?: string
}

interface HtmlProps extends CoreProps {
  dataType: DataType.Html;
}

interface TextProps extends CoreProps {
  dataType: DataType.PlainText;
}

export type ITextEditorProps = TextProps | HtmlProps;

export enum ToolbarOptions {
  Minimal,
  PriceCalculator,
  MessageSnippets,
  Headings,
}
